import { useContext, useState } from "react";
import styles from "./styles.module.css";
import CloseIcon from "@mui/icons-material/Close";
import DataTable from "../../utils/DataTable";
import Info from "../../utils/Alert/Info";
import DateTimeHelpers from "helpers/DateTimeHelpers";
import Button from "@mui/material/Button";
import PrinterImg from "images/svg/printer.svg";
import { roundOff } from "helpers/NumberFormatHelper";
import ShopContext from "../../../context/ShopContext";
import * as ReportHelper from "helpers/ReportHelper";
import { getShiftFromLocalStorage } from "helpers/ReportHelper";
import * as EditedSaleHelper from "helpers/EditedSaleHelper";
import { STORAGE_KEYS } from "const";
import EditedSaleDetailsPopup from "./EditedSaleDetailsPopup";

export default function EditedSalesPopup({ onClose, editedSales, shiftId }) {
  const { shop } = useContext(ShopContext);
  const [selectedSaleLocalId, setSelectedSaleLocalId] = useState(null);

  const listHeader = [
    {
      id: "sn",
      label: "#",
      type: "callback",
      width: "40px",
      viewRender: (item) => editedSales.indexOf(item) + 1,
    },
    {
      id: "billNo",
      label: "Bill No",
      type: "text",
      width: "120px",
    },
    {
      id: "time",
      label: "Original Time",
      type: "callback",
      width: "180px",
      viewRender: (item) => DateTimeHelpers.formatDateAndTime(item.time),
    },
    {
      id: "editedAt",
      label: "Edited Time",
      type: "callback",
      width: "180px",
      viewRender: (item) => DateTimeHelpers.formatDateAndTime(item.editedAt),
    },
    {
      id: "previousAmount",
      label: "Original Amt",
      type: "callback",
      width: "110px",
      viewRender: (item) => roundOff(item.previousAmount || 0),
    },
    {
      id: "newAmount",
      label: "New Amt",
      type: "callback",
      width: "110px",
      viewRender: (item) => {
        const isDecreased = Number(item.newAmount || 0) < Number(item.previousAmount || 0);
        return <span style={isDecreased ? { color: "red" } : {}}>{roundOff(item.newAmount || 0)}</span>;
      },
    },
  ];

  const handlePrint = async () => {
    try {
      if (!editedSales || editedSales.length === 0) return;
      const currentShiftId = shiftId || localStorage.getItem(STORAGE_KEYS.SHIFT_ID);
      const slipBytes = EditedSaleHelper.getEditedSalesPrintText(
        editedSales,
        shop,
        getShiftFromLocalStorage(currentShiftId),
      );
      await ReportHelper.printReport({ reportText: slipBytes, fallbackFunction: window.print });
    } catch (err) {
      console.error("Failed to print edited sales", err);
    }
  };

  return (
    <div className={styles.popUp}>
      <div className={styles.contentWrapper}>
        <div className={styles.headerSection}>
          <h2 className={styles.editTitle}>Edited Sales</h2>
          <div className={styles.actionSection}>
            <div className={styles.buttonBar}>
              <Button
                className={`${styles.button} ${styles.printBtn}`}
                onClick={handlePrint}
                startIcon={<img src={PrinterImg} alt="Print" className={styles.iconSmall} />}
                disabled={!editedSales || editedSales.length === 0}
              >
                Print
              </Button>
            </div>
            <CloseIcon style={{ color: "rgba(124, 124, 125, 1)", cursor: "pointer" }} onClick={onClose} />
          </div>
        </div>
        <div className={styles.tableContent}>
          {editedSales && editedSales.length > 0 ? (
            <DataTable
              columns={listHeader}
              rows={editedSales}
              rowClickListener={(item) => setSelectedSaleLocalId(item.local_id)}
            />
          ) : (
            <Info title={"No Edited Sales"} content={"There are no edited sales for this shift."} />
          )}
        </div>
      </div>

      {selectedSaleLocalId && (
        <EditedSaleDetailsPopup
          open={!!selectedSaleLocalId}
          onClose={() => setSelectedSaleLocalId(null)}
          editedSale={editedSales.find((s) => s.local_id === selectedSaleLocalId)}
        />
      )}
    </div>
  );
}
